import React from "react";
import Box from "../Box.js";

export default class TrudatThree extends React.Component {
  render() {
    return (
      <div className="hp__block hp__block__three container">
        <div className="row">
          <div className="hp__block__row-wrapper col-md-4">
            <Box
              {...this.props}
              type="tetragon"
              id="b3"
              settings={this.props.settings.b3}
              classes="hp__box__background-tetragon-wide-small hp__box__tetragon-first"
            />
          </div>
          <div className="hp__block__row-wrapper col-md-4">
            <Box
              {...this.props}
              type="tetragon"
              id="b4"
              settings={this.props.settings.b4}
              classes="hp__box__background-tetragon-wide-small hp__box__tetragon-second"
            />
          </div>
          <div className="hp__block__row-wrapper col-md-4">
            <Box
              {...this.props}
              type="tetragon"
              id="b5"
              settings={this.props.settings.b5}
              classes="hp__box__background-tetragon-wide-small hp__box__tetragon-second"
            />
          </div>
        </div>
      </div>
    );
  }
}
